<script lang="ts">
    import { uid, millisToDays } from '@cwd/shared/utils';
    import vm from '@journeys/Journeys.viewmodel';
    import { ref } from 'vue';

    import { ConditionOptions } from './Partials/ConditionList';

    const component = {
        name: 'RecursiveSegmentList',
    };

    export default {
        name: component.name,
    };
</script>

<script lang="ts" setup>
    const { account } = vm,
        instanceId = uid();

    const props = defineProps<{
        segments: any;
        depth: number;
        bool: number;
    }>();

    const highlightSegment = ref(false),
        handleMouseEnter = () => (highlightSegment.value = true),
        handleMouseLeave = () => (highlightSegment.value = false);
</script>

<template>
    <div class="group-layer" :class="highlightSegment ? 'highlight-segment' : ''" @mouseover.stop="handleMouseEnter" @mouseout.stop="handleMouseLeave">
        <h3 class="h5 group-text">
            <strong>Group</strong>
            :
            <!-- <span>{{ segment.Name }}</span> -->
            <span class="sg-bool">{{ bool === 1 ? 'AND' : bool === 2 ? 'OR' : depth }}</span>
        </h3>
        <!-- <div v-for="(segment, idx) of segments" class="segment-entry" :key="depth + instanceId" :style="`margin-bottom: ${ idx === segments.length-1 ? 6 : 0 }px`"> -->
        <div class="segment-layer">
            <div v-for="(segment, idx) of segments" :key="depth + instanceId" class="segment-entry">
                <span v-if="idx !== 0" class="bool-operator">{{ bool === 1 ? 'AND' : bool === 2 ? 'OR' : depth }}</span>

                <span class="segment-text">
                    <template v-if="segment.Type !== 'SegmentGroup'">
                        <strong>{{ segment.Type?.replace('Segment', '') }}</strong>
                        :

                        <span>{{ segment.Name }}</span>
                    </template>
                    <!-- <span v-if="segment.Type === 'SegmentGroup'" class="sg-bool"> - {{ (segment.Bool === 1 ? 'AND' : segment.Bool === 2 ? 'OR' : depth) }} -</span> -->

                    <template v-if="segment.Type === 'AgeSegment'">
                        <span>between</span>
                        <strong>{{ segment.MinAge || 'N/A' }}</strong>
                        <span>and</span>
                        <strong>{{ segment.MaxAge || 'N/A' }}</strong>
                    </template>

                    <template v-if="segment.Type === 'MemberSegment'">
                        <span>{{ ConditionOptions[segment.Type].InList.find((o: any) => o.value === segment.InList)?.resourceKey }} in</span>

                        <strong>{{ account.listings.getListing('/lists', segment.ListId)?.Name?.toUpperCase() }}</strong>
                    </template>

                    <template v-if="segment.Type === 'SegmentMemberSegment'">
                        <span>{{ ConditionOptions[segment.Type].InSegment.find((o: any) => o.value === segment.InSegment)?.resourceKey }} in</span>

                        <strong>{{ account.listings.getListing('/segments', segment.SegmentId)?.Name?.toUpperCase() }}</strong>
                    </template>

                    <template v-if="segment.Type === 'TagSegment'">
                        <span>{{ ConditionOptions[segment.Type].HasTags.find((o: any) => o.value === segment.HasTags)?.resourceKey + ' ' }}</span>
                        <span>{{ ConditionOptions[segment.Type].Bool.find((o: any) => o.value === segment.Bool)?.resourceKey }} from</span>

                        <strong>List ({{ segment.TagIds?.length }})</strong>
                    </template>

                    <template v-if="segment.Type === 'PropertySegment'">
                        <span>{{ ConditionOptions[segment.Type].Property.find((o: any) => o.value === segment.Property)?.resourceKey + ' ' }}</span>
                        <span>{{ ConditionOptions[segment.Type].Operator.find((o: any) => o.value === segment.Operator)?.resourceKey + ' ' }}</span>

                        <strong>{{ segment.Value }}</strong>
                    </template>

                    <template v-if="segment.Type === 'RecipientSegment'">
                        <span>
                            {{ ConditionOptions[segment.Type].ReceivedMailing.find((o: any) => o.value === segment.ReceivedMailing)?.resourceKey }} recieved
                        </span>
                        <strong>
                            {{
                                account.listings.getListing('/issues/listing', segment.IssueId)?.Subject?.toUpperCase() +
                                ' (' +
                                (account.listings.getListing('/issues/listing', segment.IssueId)?.IssueName || 'N/A') +
                                ') '
                            }}
                        </strong>
                        <template v-if="segment.Operator">
                            <span>{{ ConditionOptions[segment.Type].Operator.find((o: any) => o.value === segment.Operator)?.resourceKey + ' ' }}</span>

                            <!-- <strong>{{ segment.Date }}</strong> -->
                            <template v-if="segment.TimeSpanSince">
                                <!-- <span> + </span> -->
                                <strong>{{ segment.TimeSpanSince }}</strong>
                            </template>
                        </template>
                    </template>

                    <template v-if="segment.Type === 'InteractionSegment'">
                        <span>{{ ConditionOptions[segment.Type].HasInteractions.find((o: any) => o.value === segment.HasInteractions)?.resourceKey }} in</span>

                        <strong>{{ account.listings.getListing('/issues/listing', segment.IssueId)?.Name?.toUpperCase() }}</strong>
                    </template>

                    <template v-if="segment.Type === 'SurveyRespondentSegment'">
                        <span>
                            {{ ConditionOptions[segment.Type].HasReceivedEmail.find((o: any) => o.value === segment.HasReceivedEmail)?.resourceKey }} recieved
                            email and
                        </span>
                        <span>
                            {{ ConditionOptions[segment.Type].HasResponded.find((o: any) => o.value === segment.HasResponded)?.resourceKey }} responded to
                        </span>

                        <strong>{{ account.listings.getListing('/survey/listing', segment.SurveyId)?.Title?.toUpperCase() }}</strong>
                    </template>

                    <template v-if="segment.Type === 'EventParticipantIssueSegment'">
                        <span>
                            {{ ConditionOptions[segment.Type].HasReceivedEmail.find((o: any) => o.value === segment.HasReceivedEmail)?.resourceKey }} any email
                            regarding
                        </span>
                        <strong>{{ account.listings.getListing('/events/listing', segment.EventId)?.Name?.toUpperCase() }}</strong>

                        <span>
                            and {{ ConditionOptions[segment.Type].HasStatus.find((o: any) => o.value === segment.HasStatus)?.resourceKey }} any of statuses in
                        </span>

                        <strong>List ({{ segment.Statuses?.length }})</strong>
                    </template>

                    <template v-if="segment.Type === 'EventParticipantSmsSegment'">
                        <span>
                            {{ ConditionOptions[segment.Type].HasReceivedSms.find((o: any) => o.value === segment.HasReceivedSms)?.resourceKey }} any text
                            message regarding
                        </span>
                        <strong>{{ account.listings.getListing('/events/listing', segment.EventId)?.Name?.toUpperCase() }}</strong>

                        <span>
                            and {{ ConditionOptions[segment.Type].HasStatus.find((o: any) => o.value === segment.HasStatus)?.resourceKey }} any of statuses in
                        </span>

                        <strong>List ({{ segment.Statuses?.length }})</strong>
                    </template>

                    <template v-if="segment.Type === 'EventParticipantSegment'">
                        <span>
                            {{ ConditionOptions[segment.Type].HasReceivedEmail.find((o: any) => o.value === segment.HasReceivedEmail)?.resourceKey }} any email
                            regarding
                        </span>
                        <strong>{{ account.listings.getListing('/events/listing', segment.EventId)?.Name?.toUpperCase() }}</strong>

                        <span>
                            and {{ ConditionOptions[segment.Type].HasStatus.find((o: any) => o.value === segment.HasStatus)?.resourceKey }} any of statuses in
                        </span>

                        <strong>List ({{ segment.Statuses?.length }})</strong>
                    </template>

                    <RecursiveSegmentList
                        v-if="segment.Segments"
                        :segments="segment.Segments"
                        :bool="segment.Type === 'SegmentGroup' ? segment.Bool : bool"
                        :depth="depth + 1" />
                </span>
            </div>
        </div>
    </div>
</template>

<style>
    .segment-layer {
        font-size: small;
    }

    .segment-entry:last-child {
        margin-bottom: 10px;
    }

    span.sg-bool,
    .bool-operator {
        display: inline-block;
        padding: 3px;
        border: 1px solid var(--border-color);
        border-radius: var(--border-radius);
        width: fit-content;
        line-height: 1;
        font-weight: 600;
    }

    .bool-operator {
        display: block;
        font-size: smaller;
        margin: 5px 0;
    }
</style>
